import { FC } from "react";
import { useSelector } from "react-redux";

import { SettingsButton } from "~/subApps/sheet/components/SettingsButton";
import { Header } from "~/subApps/sheet/components/Sidebar/components/Header";
import { SettingsContextsEnum } from "~/tools/js/Shared/containers/panes/SettingsPane/typings";
import { appEnvSelectors } from "~/tools/js/Shared/selectors";

import { FeatShoppe } from "./FeatShoppe";

export const FeatsManagePane: FC<{}> = () => {
  const isReadonly = useSelector(appEnvSelectors.getIsReadonly);
  if (isReadonly) {
    return null;
  }

  return (
    <div>
      <Header
        callout={
          !isReadonly && (
            <SettingsButton context={SettingsContextsEnum.FEATURES} />
          )
        }
      >
        Manage Feats
      </Header>
      <FeatShoppe />
    </div>
  );
};
